var cibQuantcast = ["32 32", "<path d='M20.146 27.297c3.854-2.458 6.182-6.724 6.172-11.297 0-7.365-5.896-13.333-13.161-13.333s-13.156 5.969-13.156 13.333c0 7.365 5.891 13.333 13.156 13.333h18.844v-2.036z'/>"];

export { cibQuantcast };

